import * as React from "react";
import * as Snippets from "snippets";
import { GlobalProps, Product } from "types";
import { ShopifyNext } from "@dotdev/next-components";
import * as Helpers from "helpers";
import Slick from "react-slick";

export class ProductUpsellContainer extends React.PureComponent<
  ProductUpsellContainer.Props
> {
  public render(): JSX.Element {
    const { upsellProducts, upsellHeading, upsellMessage } = this.props;
    return (
      <div className="mt-3-2 upsell-where-you-at">
        {upsellHeading && (
          <Snippets.Heading
            size="p"
            tag="p"
            className="text-xs font-bold tracking-wide uppercase leading-tight"
          >
            {upsellHeading}
          </Snippets.Heading>
        )}
        {upsellMessage && (
          <Snippets.RichText
            size="xs"
            className="font-light text-xs mb-0-8 pdp-upsell__subheading"
          >
            {upsellMessage}
          </Snippets.RichText>
        )}
        <ProductUpsellGrid upsellProducts={upsellProducts} />
      </div>
    );
  }
}

export class ProductUpsellGrid extends React.Component<
  ProductUpsellGrid.Props,
  ProductUpsellGrid.State
> {
  public static contextType = ShopifyNext.Context;

  private slider: any;
  public constructor(props) {
    super(props);
    this.slider = React.createRef();
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.state = {
      fetched: false,
      products: [],
      slider: null,
      thumbSlider: null,
      currentSlide: 0
    };
  }

  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  private sliderSettings = {
    adaptiveHeight: true,
    dots: false,
    arrows: false,
    infinite: true,
    swipe: true,
    pauseOnHover: false,
    swipeToSlide: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    draggable: true,
    beforeChange: (_current: number, next: number) => this.selectMedia(next)
  };

  private handleAddToCart = async (e, variant) => {
    e.preventDefault();
    // window.item = {
    //   'Name': prod.name,
    //   'ProductID': prod.id,
    //   'Categories': prod.collection_name,
    //   'ImageURL': prod.thumbnailImageUrl,
    //   'URL': `https://${prod.vendor}${prod.url}`,
    //   'Brand':  prod.vendor,
    //   'Price': '$' + variant.price,
    //   'CompareAtPrice': '$' + variant.compare_at_price
    // }
    const variantId = variant.id.split("/").slice(-1)[0];
    const { limitedCartItems } = this.context.state;
    const hasReachedMaximumQty =
      limitedCartItems[`${variantId}`] &&
      Helpers.getMaxSelectableQuantity(variant) <=
        limitedCartItems[`${variantId}`];

    // early exit if reached maximum quantity
    if (hasReachedMaximumQty) {
      this.context.update({
        cartActive: true,
        message: "CART_ITEM_REACHED_MAX_QTY",
        showMessage: true
      });
    } else {
      await ShopifyNext.Cart.addItem(parseInt(variantId, 10), 1);
      this.context.update({
        cartActive: true,
        showMessage: true
      });
    }

    setTimeout(() => {
      this.context.update({
        showMessage: false
      });
    }, 3000);
  };

  private selectMedia = (index: number): any => {
    this.state.currentSlide !== index
      ? this.setState({
          currentSlide: index
        })
      : null;
  };

  private static kewl = new Helpers.ShopifyKewl({
    //@ts-ignore
    store: STOREFRONT_NAME,
    //@ts-ignore
    storeFrontKey: STOREFRONT_PASSWORD
  });

  public componentDidMount = async () => {
    const { upsellProducts } = this.props;

    const products = await ProductUpsellGrid.kewl
      .productsByHandles(upsellProducts, [
        "title",
        "id",
        "handle",
        "price",
        "images",
        "variants"
      ])
      .then(res => res.filter(prod => prod.id));

    this.setState({
      fetched: true,
      products
    });
  };

  public render(): JSX.Element {
    return (
      <>
        {this.state.products.length > 3 ? (
          <div
            style={{
              textAlign: "right",
              marginTop: "-30px",
              width: "fit-content",
              float: "right"
            }}
          >
            <button
              className={
                "outline-none opacity-30 hover:opacity-100 mr-1-5 ml-0-5"
              }
              onClick={this.previous}
            >
              <span className={"block"}>
                <Snippets.Icon name={"chevron_left"} width={18} />
              </span>
            </button>
            <button
              className={"outline-none opacity-30 hover:opacity-100"}
              onClick={this.next}
            >
              <span className={"block"}>
                <Snippets.Icon name={"chevron_right"} width={18} />
              </span>
            </button>
          </div>
        ) : null}

        {this.state.products.length > 0 ? (
          <Slick ref={c => (this.slider = c)} {...this.sliderSettings}>
            {this.state.products.map((prod: Product) => {
              const image =
                prod.images && prod.images[0]
                  ? typeof prod.images[0] === "string"
                    ? prod.images[0]
                    : prod.images[0].src
                  : null;

              return (
                <div key={prod.id} className="group flex-1">
                  <a
                    href={`/products/${prod.handle}`}
                    className={"block h-full"}
                  >
                    <Snippets.BlockImage
                      alt={prod.title || "product image"}
                      image={image}
                      ratio={"5:6"}
                      preventLazy={true}
                      className={"mb-0-8"}
                    />
                    <p
                      className="text-xs font-bold underline"
                      onClick={e => this.handleAddToCart(e, prod.variants[0])}
                    >
                      ADD:&nbsp;
                      <Snippets.Money
                        bold={true}
                        price={prod.price_min}
                        multiCurrencyTransform={true}
                      />
                    </p>
                  </a>
                </div>
              );
            })}
          </Slick>
        ) : null}
      </>
    );
  }
}

export namespace ProductUpsellContainer {
  export interface Props {
    upsellProducts: Array<string>;
    upsellHeading: string;
    upsellMessage: string;
  }
}

export namespace ProductUpsellGrid {
  export interface Props {
    upsellProducts: Array<string>;
  }

  export interface State {
    fetched: boolean;
    products: any;
    slider: any;
    thumbSlider: any;
    currentSlide: number;
  }
}
